import * as v from 'valibot';

const NotificationActionSchema = v.object({
  name: v.nullable(v.string()),
  text: v.string(),
  target: v.string(),
  targetType: v.string(),
  leadsToUserActionFulfillment: v.boolean(),
});

export const NotificationSchema = v.object({
  action: v.optional(NotificationActionSchema),
  campaignId: v.nullable(v.string()),
  campaignName: v.nullable(v.string()),
  slug: v.nullable(v.string()),
  templateId: v.nullable(v.string()),
  templateName: v.nullable(v.string()),
  body: v.string(),
  createdAt: v.string(),
  id: v.string(),
  isDismissed: v.boolean(),
  isRead: v.boolean(),
  pinDetails: v.nullable(
    v.object({
      isPinned: v.boolean(),
    }),
  ),
});

export const GetNotificationsSchema = v.object({
  notifications: v.object({
    items: v.nullable(v.array(NotificationSchema)),
  }),
});
